module.exports = __webpack_public_path__ + "img/p4.d901af88.jpg";